import React from "react";
import CustomModal from "../../common/general/CustomModal/CustomModal";
import DeleteResource from "../DeleteResource/DeleteResource";

const DeleteResourceModalContainer = ({ visible, onClose, onDeleteResource, type, isDeleting }) => {
  const getDisplayName = (resourceType) => {
    const displayNames = {
      review: "Review",
      aiTutor: "AiTutor",
      aitutor: "AiTutor",
      assignment: "Assignment",
      resource: "Resource",
      axioResource: "Resource",
      module: "Module",
      ACTIVITY_REVIEW: "Review",
      ACTIVITY_INTERACTIVE_LEARNING_EXPERIENCE: "AI Tutor",
      ACTIVITY_ASSIGNMENT: "Assignment",
      ACTIVITY_RESOURCE: "Resource",
      MODULE: "Module",
    };

    return displayNames[resourceType] || resourceType;
  };

  const handleDelete = () => {
    onDeleteResource();
  };

  const displayName = getDisplayName(type);

  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title={`Delete ${displayName}`}>
      <DeleteResource
        deleteButtonClick={handleDelete}
        backButtonClick={onClose}
        type={displayName}
        isDeleting={isDeleting}
      />
    </CustomModal>
  );
};

export default DeleteResourceModalContainer;
